import { useEffect, useState } from 'react';
import type { Role } from '@flintmint/core-shared/constants';
import { subscribeToUserRoles } from '@/services/user-roles-service';

export const useUserRoles = () => {
  const [rolesByUserId, setRolesByUserId] = useState<Map<string, Role[]>>(new Map());
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    return subscribeToUserRoles(
      (data) => {
        setRolesByUserId(data);
        setIsLoading(false);
      },
      (subscribeError) => {
        setError(subscribeError.message);
        setIsLoading(false);
      }
    );
  }, []);

  return { rolesByUserId, isLoading, error };
};
